const PARDOT_FORM_URLS = {
  DEMO:
    'https://info.onupkeep.com/l/500441/2020-01-27/cbdxy?success_location=https://www.onupkeep.com/success&conversion_page=https://www.onupkeep.com/demo',
  DEMO_CHILIPIPER: 'https://info.upkeep.com/l/500441/2022-12-16/s1r34',
  NEWSLETTER: 'https://info.onupkeep.com/l/500441/2018-02-06/28vqy',
  NEWSLETTER_SIGNUP_LIST: 'https://info.onupkeep.com/l/500441/2021-02-25/gypvm',
  FREE_TRIAL: 'https://info.onupkeep.com/l/500441/2021-06-08/hsj9j',
  FREE_TRIAL_SALES: 'https://info.onupkeep.com/l/500441/2021-03-10/h3r83',
  GATED_CONTENT: 'https://info.onupkeep.com/l/500441/2021-07-12/hzl29',
  EDGE_CONTACT: 'https://info.onupkeep.com/l/500441/2021-05-20/hnz66',
  TEST: 'https://info.onupkeep.com/l/500441/2021-07-01/hxnwc',
  EXIT_INTENT: 'https://info.onupkeep.com/l/500441/2021-08-11/j4x2y',
  STARTER_SUBSCRIPTION: 'https://info.onupkeep.com/l/500441/2021-11-17/kclkx',
  REQUEST_PRICING: 'https://info.onupkeep.com/l/500441/2021-12-22/mr73x',
  PARTNER_SIGNUP: 'https://info.onupkeep.com/l/500441/2022-02-09/n8hsp',
  BOOK_CONTEST: 'https://info.onupkeep.com/l/500441/2022-04-27/pddr6',
  TSHIRT_GIVEAWAY: 'https://info.onupkeep.com/l/500441/2022-09-28/r36g5',
  DEMO_CMMMS_RADIO: 'https://info.upkeep.com/l/500441/2023-11-14/wdgkx',
  MAINTENANCE_APPRECIATION: 'https://info.upkeep.com/l/500441/2024-07-18/wttvy',
  AI_INTELLIGENCE: 'https://info.upkeep.com/l/500441/2025-03-25/x8jlk',
  EHS_FORM: 'https://info.upkeep.com/l/500441/2025-06-12/xllmg',
  AI_GENERATOR: 'https://info.upkeep.com/l/500441/2025-08-14/xq8v1',
};

export const sendToPardotForm = ({
  formType,
  payload,
  params = {},
  formHandler,
}) => {
  const formUrl = formHandler || PARDOT_FORM_URLS[formType];
  if (!formUrl) {
    console.error(`Invalid form type: ${formType}`);
    return;
  }
  sendToPardotInIframe({ action: formUrl, payload, params });
};

const sendToPardotInIframe = ({ action, payload, params = null }) => {
  const iframe = document.createElement('iframe');
  iframe.height = '0';
  iframe.width = '0';
  iframe.id = 'hidden_pardot_iframe';
  iframe.name = 'hidden_pardot_iframe';
  iframe.sandbox = 'allow-scripts allow-forms allow-same-origin';
  document.body.appendChild(iframe);

  const form = iframe.contentWindow.document.createElement('form');
  form.method = 'post';
  form.id = 'pardot-form';
  form.action = action;
  form.target = 'hidden_pardot_iframe';
  for (const field in payload) {
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = field;
    hiddenField.value = payload[field];
    form.appendChild(hiddenField);
  }
  for (const field in params) {
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = field;
    hiddenField.value = params[field];
    form.appendChild(hiddenField);
  }
  iframe.contentWindow.document.body.appendChild(form);
  form.submit();
};
